import { Flex, Text } from '@chakra-ui/react';
import { Price } from 'components/cart/Price';
import type { Money } from 'types/product/Money';

interface ProductSoldOutProps {
  price: Money;
}

export function ProductSoldOut({ price }: ProductSoldOutProps) {
  return (
    <Flex gap="3xs" alignItems="center">
      {price.amount > 0 && <Price size="h4" totalAmount={price} />}
      <Text size="h4" color="blackAlpha.600">
        Sold out
      </Text>
    </Flex>
  );
}
